import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import BluebirdPromise from 'bluebird';
import FullPageContent from '../../../shared/components/FullPageContent';
import Page from '../../../shared/components/Page';
import NextAssetContainer from './NextAssetContainer';
import CollectionContainer from './CollectionContainer';
import FullPageLoadingIndicator from '../../../shared/components/FullPageLoadingIndicator';
import {
    getUserLearningAsset,
    getLearningAssetRecommended,
    getManyTeams,
    getManyUserPathways,
    getManyUserCollections,
    getManyCollections
} from '../../../shared/actions';
import { postUserCollection } from '../../../shared/actions/UserCollections';
import { SEGMENT_EVENTS, LEARNING_ASSET_DURATIONS } from '../../../shared/Constants';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class LearningAssetInterstitial extends Component {
    static propTypes = {
        match: PropTypes.object,
        currentUserLearningAsset: PropTypes.object,
        getUserLearningAsset: PropTypes.func,
        getLearningAssetRecommended: PropTypes.func,
        postUserCollection: PropTypes.func,
        loggedInUser: PropTypes.object,
        behaviors: PropTypes.object,
        history: PropTypes.object,
        getManyTeams: PropTypes.func,
        loggedInUserCompany: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        teamsById: PropTypes.object,
        isAccountOwner: PropTypes.bool,
        currentUserPathway: PropTypes.object,
        getManyUserPathways: PropTypes.func,
        getManyUserCollections: PropTypes.func,
        userCollectionsById: PropTypes.object,
        userPathwaysById: PropTypes.object,
        getManyCollections: PropTypes.func
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            interstitialData: {
                assetIsInUserCollection: false,
                totalAssets: 0,
                totalComplete: 0,
                nextLearningAsset: {},
                currentCollection: {},
                currentUserCollection: {}
            },
            forcedRecommendation: false
        };
    }

    static contextType = RuntimeContext;

    componentDidMount() {
        const { match, } = this.props;
        return this._getData(match.params.userLearningAssetId).then(this._checkLastRecommendedModalAlert);
    }

    componentDidUpdate(prevProps) {
        const { match, loggedInUser } = this.props;
        if (!prevProps.loggedInUser?._id && loggedInUser?._id) {
            return this._getData(match.params.userLearningAssetId).then(this._checkLastRecommendedModalAlert);
        }
        return null;
    }

    _getData = (userLearningAssetId) => {
        const {
            getUserLearningAsset,
            getLearningAssetRecommended,
            getManyTeams,
            loggedInUser,
            getManyUserPathways,
            getManyUserCollections,
            userCollectionsById,
            userPathwaysById,
            getManyCollections
        } = this.props;
        this.setState({ loading: true });
        if (loggedInUser._id) {
            const promises = [
                getManyTeams({ pathsContext: this.context.pathsWeb }),
                getLearningAssetRecommended({ userLearningAssetId, pathsContext: this.context.pathsWeb }).then(
                    (interstitialData) => {
                        this.setState({
                            interstitialData
                        });
                    }
                ),
                getUserLearningAsset({ userLearningAssetId, pathsContext: this.context.pathsWeb }),
                getManyCollections({
                    filterByCompany: true,
                    companyId: loggedInUser.companyId,
                    pathsContext: this.context.pathsWeb
                })
            ];

            if (isEmpty(userCollectionsById)) {
                promises.push(
                    getManyUserCollections({ userProfileId: loggedInUser._id, pathsContext: this.context.pathsWeb })
                );
            }

            if (isEmpty(userPathwaysById)) {
                promises.push(
                    getManyUserPathways({ userProfileId: loggedInUser._id, pathsContext: this.context.pathsWeb })
                );
            }

            return BluebirdPromise.all(promises).then(() =>
                this.setState({
                    loading: false
                })
            );
        }
        return null;
    };

    _checkLastRecommendedModalAlert = () => {
        const lastModalAlert = window.localStorage.getItem('recommendedDateTime');

        const onARoll = [
            moment()
                .utc()
                .format()
        ]
            .concat(JSON.parse(window.localStorage.getItem('onARoll')) || [])
            .filter((assetCompletionTime) => moment(new Date()).diff(moment(assetCompletionTime), 'days') < 1);

        // store completion times for assets completed in last day
        window.localStorage.setItem('onARoll', JSON.stringify(onARoll));

        // display modal if 3 or more assets completed in last 24hrs and no recommendation modal shown in last 30 days
        // if (onARoll.length > 2 && (!lastModalAlert || moment(new Date()).diff(moment(lastModalAlert), 'days') > 30)) {
        //     this.setState({ forcedRecommendation: true, modalOpen: true });
        //     window.localStorage.setItem(
        //         'recommendedDateTime',
        //         moment()
        //             .utc()
        //             .format()
        //     );
        // }
    };

    _handleContinue = () => {
        const { history, postUserCollection, loggedInUserCompany, isVerbAdmin, currentUserLearningAsset } = this.props;
        const {
            interstitialData: { nextLearningAsset, currentUserCollection, currentCollection }
        } = this.state;
        const learningAssetDuration = LEARNING_ASSET_DURATIONS();

        const customFields = {
            learningAssetName: currentUserLearningAsset.track && currentUserLearningAsset.track.name,
            learningAssetType: currentUserLearningAsset.type || '',
            nextLearningAssetName: nextLearningAsset.name || '',
            nextLearningAssetType: nextLearningAsset.type || ''
        };

        if (
            learningAssetDuration[nextLearningAsset.durationId] &&
            learningAssetDuration[nextLearningAsset.durationId].inMinutes
        ) {
            customFields.nextLearningAssetDuration = learningAssetDuration[nextLearningAsset.durationId].inMinutes;
        }

        const attachCurrentCollection = !isEmpty(currentUserCollection);
        if (attachCurrentCollection) {
            customFields.collectionName = currentUserCollection.collectionName || '';
        }

        if (isEmpty(currentUserCollection) && !isEmpty(currentCollection)) {
            return postUserCollection({
                body: { collectionId: currentCollection._id, status: 'STARTED' },
                pathsContext: this.context.pathsWeb
            }).then((userCollection) =>
                history.push({
                    pathname: `/assetlink/${nextLearningAsset._id}`,
                    state: {
                        userCollection: {
                            id: userCollection._id,
                            started: true
                        }
                    }
                })
            );
        }
        return BluebirdPromise.resolve().then(() => history.push(`/assetlink/${nextLearningAsset._id}`));
    };

    render() {
        const {
            currentUserLearningAsset,
            loggedInUser,
            behaviors,
            currentUserPathway
        } = this.props;
        const {
            interstitialData: {
                nextLearningAsset,
                currentCollection,
                currentUserCollection,
                totalCollectionAssets,
                totalCollectionAssetsComplete
            },
            loading,
        } = this.state;

        if (loading) {
            return (
                <Page className={'asset-interstitial-experimental'}>
                    <FullPageContent>
                        <FullPageLoadingIndicator />
                    </FullPageContent>
                </Page>
            );
        }
        return (
            <Page className={'asset-interstitial-experimental'}>
                <FullPageContent className={'asset-interstitial-page'}>
                    <NextAssetContainer
                        behaviors={behaviors}
                        loggedInUser={loggedInUser}
                        nextLearningAsset={nextLearningAsset}
                        userCollection={currentUserCollection}
                        currentUserLearningAsset={currentUserLearningAsset}
                        collection={currentCollection}
                        handleContinue={this._handleContinue}
                        totalCollectionAssets={totalCollectionAssets}
                        totalCollectionAssetsComplete={totalCollectionAssetsComplete}
                        currentUserPathway={currentUserPathway}
                    />
                    <CollectionContainer
                        collection={currentCollection}
                        userCollection={currentUserCollection}
                        totalCollectionAssets={totalCollectionAssets}
                        totalCollectionAssetsComplete={totalCollectionAssetsComplete}
                        currentUserPathway={currentUserPathway}
                    />
                </FullPageContent>
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const mapStateToProps = (state, ownProps) => {
        const {
            auth: { loggedInUser, loggedInUserCompanyId, isAccountOwner, isVerbAdmin },
            userLearningAssets,
            userCollections = {},
            companies,
            behaviors,
            teams,
            userPathways = {}
        } = state;

        const {
            match: { params }
        } = ownProps;
        const currentUserLearningAsset = userLearningAssets.byId[params.userLearningAssetId] || {};
        const loggedInUserCompany = companies.byId && companies.byId[loggedInUserCompanyId];

        let currentUserPathway;

        const associatedUserCollectionIdDict = {};

        Object.values(userCollections.byId).forEach((userCollection) => {
            userCollection.content.forEach((contentItem) => {
                if (contentItem.userLearningAssetId === currentUserLearningAsset._id) {
                    associatedUserCollectionIdDict[userCollection._id] = true;
                }
            });
        });

        const allUserPathways = Object.values(userPathways.byId); // this is already sorted by createdOn desc

        for (let i = 0; i < allUserPathways.length; i += 1) {
            for (let j = 0; j < allUserPathways[i].content.length; j += 1) {
                const contentItem = allUserPathways[i].content[j];
                if (associatedUserCollectionIdDict[contentItem.userSubscriptionId]) {
                    currentUserPathway = allUserPathways[i];
                    break;
                }
            }
        }

        return {
            loggedInUser,
            currentUserLearningAsset,
            behaviors: behaviors.byId,
            isVerbAdmin,
            isAccountOwner,
            loggedInUserCompany,
            teamsById: teams.byId,
            currentUserPathway,
            userCollectionsById: userCollections.byId,
            userPathwaysById: userPathways.byId
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getUserLearningAsset: (params) => dispatch(getUserLearningAsset(params)),
    getLearningAssetRecommended: (params) => dispatch(getLearningAssetRecommended(params)),
    postUserCollection: (params) => dispatch(postUserCollection(params)),
    getManyTeams: (params) => dispatch(getManyTeams(params)),
    getManyUserPathways: (params) => dispatch(getManyUserPathways(params)),
    getManyUserCollections: (params) => dispatch(getManyUserCollections(params)),
    getManyCollections: (params) => dispatch(getManyCollections(params))
});

export const LearningAssetInterstitialV2Component = LearningAssetInterstitial;
export default connect(makeMapStateToProps, mapDispatchToProps)(LearningAssetInterstitial);
